export const CONSTANTS = {
  SAVE_MODE: {
    DRAFT: 0,
    SAVE: 1
  },
  DocumentType: {
    ProfilePic: 1,
    PhotoIdProof: 2,
    AadharCard: 3,
    PanCard: 4,
    Resume: 5,
    SevaProfileDoc: 6,
    VSDoc: 7,
    Other: 8,
    PTHDoc: 9
  },
  AddressType: {
    Unknown: 0,
    Current: 1,
    Permanant: 2,
    Emergency: 3
  },
  ApplicationTypeId: {
    SEVA_PROFIE: 1,
    VISITING_SEVA: 2,
    GURUKULA_SEVA: 3,
    HOME_SEVA: 4,
    PTH: 5,
    FAMILY_RETREAT: 6,
    KYPR: 7,
    SYPR: 7,
  },
  ApplicantApplicationType: {
    SEVA_PROFIE: 'SEVA_PROFIE',
    VISITING_SEVA: 'VISITING_SEVA',
    GURUKULA_SEVA: 'GURUKULA_SEVA',
    HOME_SEVA: 'HOME_SEVA',
    PTH: 'PTH',
    FAMILY_RETREAT: 'FAMILY_RETREAT',
    KYPR: 'KYPR',
    SYPR: 'SYPR',
  },
 
  NoteCreatorId: {
    ADMIN_NOTES: 1,
    GAO_NOTES: 2,
    FIRST_AID_NOTES: 3,
    HR_NOTES: 4,
    SEVA_CENTER_NOTES: 5,
    APPLICATION_POINT_PERSON_NOTES: 6,
    COC_NOTES: 7,
  },




  ApplicationState: {
    DRAFT: 1,
    SUBMITTED_APP_REVIEW: 2,
    NEED_EDITS_APP: 3,
    UNDER_GURUKULA_REVIEW: 4,
    NEED_EDITS_GURUKULA: 5,
    NEED_EDITS_GURUKULA_TO_APP: 6,
    APPROVED: 7,
    WAITLIST: 8,
    NON_APPROVED: 9,
    INVALID: 10,
    CLOSED: 11,
    CANCELLED: 12
  },
  COCReferenceStatus: {
    PENDING: 1,
    SUBMITTED: 2,
    NEEDS_EDITS: 3
  },
  FirstAidReviewStatus: {
    PENDING: 1,
    REVIEWED: 2,
    NEEDS_ADDITIONAL_INFORMATION: 3
  },




  MaxLength:{
    inputField: 100,
    ContemplationTextArea: 2000,
    inputTextDescription: 250,

  },
  MinLength:{
    StreetAddress: 3,
    TownCity: 3,
    District: 3,
    State: 3,
  },
  EmptyGuid: '00000000-0000-0000-0000-000000000000'
};



export const ENDPOINTS = {
  VISITING_SEVA: {
    SAVE_ACCOMMODATION_REQUEST: 'VSApplication/SaveVSAccomodationRequest',
    GET_ACCOMMODATION_REQUEST: 'VSApplication/GetVSAccomodationRequest',

    SAVE_DATE_OF_ARRIVAL: 'VSApplication/SaveArrivalScheduleData',
    GET_DATE_OF_ARRIVAL: 'VSApplication/GetArrivalScheduleData',
  },
  PTH: {
    SAVE_ACCOMMODATION_REQUEST: 'AddendumPTH/SavePTHAccomodationRequest',
    GET_ACCOMMODATION_REQUEST: 'AddendumPTH/GetPTHAccommodationRequest',
    
    SAVE_DATE_OF_ARRIVAL: 'AddendumPTH/SaveArrivalScheduleData',
    GET_DATE_OF_ARRIVAL: 'AddendumPTH/GetArrivalScheduleData',
  },
}


export const UserRole = {
  Applicant: "Applicant",
  COC: 'COC',
  AOC: 'AOC',
  ADMIN: 'ADMIN',
  GAO: 'GAO',
  SuperAdmin: 'SuperAdmin',
  APP: "APP",
  FirstAid: "FirstAid",
  SevaCenter: "SevaCenter",
  HR: "HR"
}




export const which_permission = {
  can_see_list: "can_see_list",
  can_add: "can_add",
  can_export: "can_export",
  can_modify: "can_modify",
  can_read: "can_read",

}



export const Option_Set = {
  AashramNamesOptions: "AashramNamesOptions",
  RetreatOptions: "RetreatOptions",
  AccomodationPreferenceOptions: "AccomodationPreferenceOptions",
  RelationshipOptions: "RelationshipOptions",
  AudioSatsangOptions: "AudioSatsangOptions",
}





export const RELATIONSHIP_OPTIONS = [
  { id: 1, name: 'Father' },
  { id: 2, name: 'Mother' },
  { id: 3, name: 'Brother' },
  { id: 4, name: 'Sister' },
  { id: 5, name: 'Husband' },
  { id: 6, name: 'Wife' },
  { id: 7, name: 'Son' },
  { id: 8, name: 'Daughter' },
  { id: 9, name: 'Friend' },
  { id: 10, name: 'Uncle' },
  { id: 11, name: 'Aunt' },
  { id: 12, name: 'Cousin' },
  { id: 13, name: 'Grandfather' },
  { id: 14, name: 'Grandmother' },
  { id: 15, name: 'Nephew' },
  { id: 16, name: 'Niece' },
  { id: 17, name: 'Colleague' },
  { id: 18, name: 'Neighbor' },
  { id: 19, name: 'Guardian' },
  { id: 20, name: 'Other' }
];


export const INDIAN_STATES = [
  { id: 1, name: 'Andhra Pradesh' },
  { id: 2, name: 'Arunachal Pradesh' },
  { id: 3, name: 'Assam' },
  { id: 4, name: 'Bihar' },
  { id: 5, name: 'Chhattisgarh' },
  { id: 6, name: 'Goa' },
  { id: 7, name: 'Gujarat' },
  { id: 8, name: 'Haryana' },
  { id: 9, name: 'Himachal Pradesh' },
  { id: 10, name: 'Jharkhand' },
  { id: 11, name: 'Karnataka' },
  { id: 12, name: 'Kerala' },
  { id: 13, name: 'Madhya Pradesh' },
  { id: 14, name: 'Maharashtra' },
  { id: 15, name: 'Manipur' },
  { id: 16, name: 'Meghalaya' },
  { id: 17, name: 'Mizoram' },
  { id: 18, name: 'Nagaland' },
  { id: 19, name: 'Odisha' },
  { id: 20, name: 'Punjab' },
  { id: 21, name: 'Rajasthan' },
  { id: 22, name: 'Sikkim' },
  { id: 23, name: 'Tamil Nadu' },
  { id: 24, name: 'Telangana' },
  { id: 25, name: 'Tripura' },
  { id: 26, name: 'Uttar Pradesh' },
  { id: 27, name: 'Uttarakhand' },
  { id: 28, name: 'West Bengal' },
  { id: 29, name: 'Andaman and Nicobar Islands' }, // Union Territory
  { id: 30, name: 'Chandigarh' },                 // Union Territory
  { id: 31, name: 'Dadra and Nagar Haveli and Daman and Diu' }, // Union Territory
  { id: 32, name: 'Delhi' },                      // Union Territory
  { id: 33, name: 'Jammu and Kashmir' },          // Union Territory
  { id: 34, name: 'Ladakh' },                     // Union Territory
  { id: 35, name: 'Lakshadweep' },                // Union Territory
  { id: 36, name: 'Puducherry' }                  // Union Territory
];



export const RETREAT_LIST= [
   
  {
    "OptionText": "None",
    "OptionValue": "None",
    "Id": 74,
    "CompletionPercentage": 0,
    "IsActive": true
  },
  {
      "OptionText": "Pilgrimage to the Heart",
      "OptionValue": "Pilgrimage to the Heart",
      "Id": 71,
      "CompletionPercentage": 0,
      "IsActive": true
    },
 
    {
      "OptionText": "Siddha Yoga Family Retreat",
      "OptionValue": "Siddha Yoga Family Retreat",
      "Id": 72,
      "CompletionPercentage": 0,
      "IsActive": true
    },
    {
      "OptionText": " Siddha Yoga Retreat for Young Adults",
      "OptionValue": "Siddha Yoga Retreat for Young Adults",
      "Id": 73,
      "CompletionPercentage": 0,
      "IsActive": true
    },
    
  ]


export const ASHRAM_LIST=[
  {
    "OptionText": "None",
    "OptionValue": "None",
    "Id": 64,
    "CompletionPercentage": 0,
    "IsActive": true
  },
  {
    "OptionText": "Gurudev Siddha Peeth in Ganeshpuri",
    "OptionValue": "GSP",
    "Id": 65,
    "CompletionPercentage": 0,
    "IsActive": true
  },
  {
    "OptionText": "Shree Muktananda Ashram",
    "OptionValue": "SMA",
    "Id": 66,
    "CompletionPercentage": 0,
    "IsActive": true
  },
  {
    "OptionText": "Siddha Yoga Ashram In Melbourne ",
    "OptionValue": "Melbourne ",
    "Id": 67,
    "CompletionPercentage": 0,
    "IsActive": true
  },
  {
    "OptionText": "Siddha Yoga Ashram In Sydney",
    "OptionValue": "Sydney",
    "Id": 68,
    "CompletionPercentage": 0,
    "IsActive": true
  },
  {
    "OptionText": "Siddha Yoga Ashram In Oakland ",
    "OptionValue": "Oakland",
    "Id": 69,
    "CompletionPercentage": 0,
    "IsActive": true
  },
  {
    "OptionText": "Siddha Yoga Ashram In Boston ",
    "OptionValue": "Boston",
    "Id": 70,
    "CompletionPercentage": 0,
    "IsActive": true
  }
]


export const DEGREE_OPTIONS = [
  // ===== School Education =====
  { id: 1, name: 'Primary School' },
  { id: 2, name: 'Middle School' },
  { id: 3, name: 'Secondary School (10th / SSC / Matriculation)' },
  { id: 4, name: 'Higher Secondary (12th / HSC / Intermediate)' },

  // ===== Vocational / Skill =====
  { id: 5, name: 'ITI (Industrial Training Institute)' },
  { id: 6, name: 'Polytechnic Diploma' },
  { id: 7, name: 'Vocational Training / Skill Course' },
  { id: 8, name: 'Certificate Course' },

  // ===== Diploma =====
  { id: 9, name: 'Diploma' },
  { id: 10, name: 'Advanced Diploma' },
  { id: 11, name: 'Post Diploma' },

  // ===== Undergraduate – General =====
  { id: 12, name: 'BA (Bachelor of Arts)' },
  { id: 13, name: 'BSc (Bachelor of Science)' },
  { id: 14, name: 'BCom (Bachelor of Commerce)' },
  { id: 15, name: 'BBA (Bachelor of Business Administration)' },
  { id: 16, name: 'BCA (Bachelor of Computer Applications)' },

  // ===== Undergraduate – Engineering / Technology =====
  { id: 17, name: 'BE / BTech – Mechanical Engineering' },
  { id: 18, name: 'BE / BTech – Electrical Engineering' },
  { id: 19, name: 'BE / BTech – Electronics Engineering' },
  { id: 20, name: 'BE / BTech – Electronics & Telecommunication Engineering' },
  { id: 21, name: 'BE / BTech – Computer Engineering' },
  { id: 22, name: 'BE / BTech – Computer Science Engineering' },
  { id: 23, name: 'BE / BTech – Information Technology' },
  { id: 24, name: 'BE / BTech – Civil Engineering' },
  { id: 25, name: 'BE / BTech – Chemical Engineering' },
  { id: 26, name: 'BE / BTech – Production Engineering' },
  { id: 27, name: 'BE / BTech – Industrial Engineering' },
  { id: 28, name: 'BE / BTech – Automobile Engineering' },
  { id: 29, name: 'BE / BTech – Mechatronics Engineering' },
  { id: 30, name: 'BE / BTech – Aerospace Engineering' },
  { id: 31, name: 'BE / BTech – Aeronautical Engineering' },
  { id: 32, name: 'BE / BTech – Robotics Engineering' },
  { id: 33, name: 'BE / BTech – Marine Engineering' },
  { id: 34, name: 'BE / BTech – Biomedical Engineering' },
  { id: 35, name: 'BE / BTech – Instrumentation Engineering' },
  { id: 36, name: 'BE / BTech – Textile Engineering' },
  { id: 37, name: 'BE / BTech – Mining Engineering' },
  { id: 38, name: 'BE / BTech – Metallurgical Engineering' },
  { id: 39, name: 'BE / BTech – Petroleum Engineering' },
  { id: 40, name: 'BE / BTech – Agricultural Engineering' },
  { id: 41, name: 'BE / BTech – Food Technology' },
  { id: 42, name: 'BE / BTech – Environmental Engineering' },
  { id: 43, name: 'BE / BTech – Artificial Intelligence' },
  { id: 44, name: 'BE / BTech – Artificial Intelligence & Machine Learning' },
  { id: 45, name: 'BE / BTech – Data Science' },
  { id: 46, name: 'BE / BTech – Cyber Security' },
  { id: 47, name: 'BE / BTech – Internet of Things (IoT)' },
  { id: 48, name: 'BE / BTech – Other Engineering' },

  // ===== Undergraduate – Medical / Health =====
  { id: 49, name: 'MBBS' },
  { id: 50, name: 'BDS (Dental Surgery)' },
  { id: 51, name: 'BAMS (Ayurveda)' },
  { id: 52, name: 'BHMS (Homeopathy)' },
  { id: 53, name: 'BUMS (Unani Medicine)' },
  { id: 54, name: 'BNYS (Naturopathy & Yoga)' },
  { id: 55, name: 'BPharm (Pharmacy)' },
  { id: 56, name: 'BPT (Physiotherapy)' },
  { id: 57, name: 'BSc Nursing' },

  // ===== Undergraduate – Law / Education / Arts =====
  { id: 58, name: 'LLB (Bachelor of Law)' },
  { id: 59, name: 'BEd (Bachelor of Education)' },
  { id: 60, name: 'BFA (Fine Arts)' },
  { id: 61, name: 'BHM (Hotel Management)' },
  { id: 62, name: 'BArch (Architecture)' },

  // ===== Professional Qualifications =====
  { id: 63, name: 'CA (Chartered Accountant)' },
  { id: 64, name: 'CS (Company Secretary)' },
  { id: 65, name: 'CMA (Cost & Management Accountant)' },

  // ===== Postgraduate – General =====
  { id: 66, name: 'MA (Master of Arts)' },
  { id: 67, name: 'MSc (Master of Science)' },
  { id: 68, name: 'MCom (Master of Commerce)' },
  { id: 69, name: 'MBA (Master of Business Administration)' },
  { id: 70, name: 'MCA (Master of Computer Applications)' },

  // ===== Postgraduate – Engineering / Technical =====
  { id: 71, name: 'ME (Master of Engineering)' },
  { id: 72, name: 'MTech (Master of Technology)' },
  { id: 73, name: 'MPharm (Master of Pharmacy)' },
  { id: 74, name: 'MPT (Physiotherapy)' },
  { id: 75, name: 'MSc Nursing' },
  { id: 76, name: 'LLM (Master of Law)' },
  { id: 77, name: 'MEd (Master of Education)' },
  { id: 78, name: 'MArch (Architecture)' },

  // ===== Medical Postgraduate =====
  { id: 79, name: 'MD (Doctor of Medicine)' },
  { id: 80, name: 'MS (Master of Surgery)' },
  { id: 81, name: 'DM (Doctorate of Medicine)' },
  { id: 82, name: 'MCh (Master of Chirurgiae)' },

  // ===== Research =====
  { id: 83, name: 'M.Phil' },
  { id: 84, name: 'PhD (Doctor of Philosophy)' },
  { id: 85, name: 'Post Doctoral Fellowship' },

  // ===== Other =====
  { id: 86, name: 'Professional Degree (Other)' },
  { id: 87, name: 'Other' }
];
















export const APP_MENU = [
  
  {
    title: 'Admin Dashboard',
    icon: { icon: 'profile', pack: 'myicons' },
    link: '/admin',
    role: [UserRole.SuperAdmin]
  },

  {
    title: 'Dashboard',
    icon: { icon: 'profile', pack: 'myicons' },
    link: '/gao',
    role: [UserRole.GAO]
  },
  {
    title: 'Dashboard',
    icon: { icon: 'profile', pack: 'myicons' },
    link: '/app',
    role: [UserRole.APP]
  },
  {
    title: 'Dashboard',
    icon: { icon: 'profile', pack: 'myicons' },
    link: '/coc',
    role: [UserRole.COC]
  },
  {
    title: 'Dashboard',
    icon: { icon: 'profile', pack: 'myicons' },
    link: '/firstAid',
    role: [UserRole.FirstAid]
  },  {
    title: 'Dashboard',
    icon: { icon: 'profile', pack: 'myicons' },
    link: '/seva-center',
    role: [ UserRole.SevaCenter]
  },
  {
    title: 'Dashboard',
    icon: { icon: 'profile', pack: 'myicons' },
    link: '/hr',
    role: [ UserRole.HR]
  },
  {
    title: 'Applications',
    icon: { icon: 'profile', pack: 'myicons' },
    link: '/admin/applications',
    role: [UserRole.SuperAdmin]
  },
  {
    title: 'User Role',
    icon: { icon: 'profile', pack: 'myicons' },
    link: '/admin/user-role',
    role: [UserRole.SuperAdmin]
  },
  {
    title: 'Center',
    icon: { icon: 'profile', pack: 'myicons' },
    link: '/admin/centers',
    role: [UserRole.SuperAdmin]
  },
  {
    title: 'Applications',
    icon: { icon: 'profile', pack: 'myicons' },
    link: '/gao/applications',
    visibleTo: [UserRole.Applicant],
    role: [UserRole.GAO]
    // role: [UserRole.SuperAdmin, UserRole.GAO]
  },
  {
    title: 'Applications',
    icon: { icon: 'profile', pack: 'myicons' },
    link: '/app/applications',
    visibleTo: [UserRole.Applicant],
    role: [ UserRole.APP]
  },
  {
    title: 'Applications',
    icon: { icon: 'grievance', pack: 'myicons' },
    link: '/coc/applications',
    role: [ UserRole.COC]
  },
  {
    title: 'Applications',
    icon: { icon: 'grievance', pack: 'myicons' },
    link: '/firstAid/applications',
    role: [ UserRole.FirstAid]
  },
  {
    title: 'Applications',
    icon: { icon: 'grievance', pack: 'myicons' },
    link: '/seva-center/applications',
    role: [ UserRole.SevaCenter]
  },
  {
    title: 'Applications',
    icon: { icon: 'grievance', pack: 'myicons' },
    link: '/hr/applications',
    role: [UserRole.HR]
  },
  // {
  //   title: 'Applicant',
  //   icon: { icon: 'grievance', pack: 'myicons' },
  //   link: '/applicant/profile-summary',
  //   role: [
  //     UserRole.SuperAdmin,
  //     UserRole.Applicant,
  //     UserRole.SevaCenter,
  //     UserRole.COC,
  //     UserRole.AOC,
  //     UserRole.GAO,
  //     UserRole.FirstAid,
  //     UserRole.APP,
  //     UserRole.HR
  //   ]
  // },
  {
    title: 'Logout',
    icon: { icon: 'logout', pack: 'myicons' },
    link: '/',
    role: [
      UserRole.SuperAdmin,
      UserRole.Applicant,
      UserRole.SevaCenter,
      UserRole.COC,
      UserRole.AOC,
      UserRole.GAO,
      UserRole.FirstAid,
      UserRole.APP,
      UserRole.HR
    ]
  }
];